import(/* webpackMode: "eager", webpackExports: ["ButtonTracker"] */ "/root/options-saas/components/analytics/button-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatadogInit"] */ "/root/options-saas/components/analytics/datadog-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/options-saas/components/modals/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferralTracker"] */ "/root/options-saas/components/referral-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTopButton"] */ "/root/options-saas/components/shared/ScrollToTopButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/root/options-saas/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/root/options-saas/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/root/options-saas/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/root/options-saas/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/root/options-saas/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/root/options-saas/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/root/options-saas/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/root/options-saas/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/root/options-saas/node_modules/react-grid-layout/css/styles.css");
;
import(/* webpackMode: "eager" */ "/root/options-saas/node_modules/react-resizable/css/styles.css");
;
import(/* webpackMode: "eager" */ "/root/options-saas/node_modules/next/font/google/target.css?{\"path\":\"assets/fonts/index.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\",\"display\":\"swap\",\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager" */ "/root/options-saas/node_modules/next/font/google/target.css?{\"path\":\"assets/fonts/index.ts\",\"import\":\"Urbanist\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-urban\",\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"fontUrban\"}");
;
import(/* webpackMode: "eager" */ "/root/options-saas/node_modules/next/font/google/target.css?{\"path\":\"assets/fonts/index.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-heading\",\"display\":\"swap\"}],\"variableName\":\"fontHeading\"}");
;
import(/* webpackMode: "eager" */ "/root/options-saas/node_modules/next/font/local/target.css?{\"path\":\"assets/fonts/index.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./GeistVF.woff2\",\"variable\":\"--font-geist\"}],\"variableName\":\"fontGeist\"}");
